import { ComponentProps } from 'react';
import { useField } from 'formik';
import SingleSelectControlled from '../SingleSelectControlled';

interface SingleSelectProps
  extends Omit<
    ComponentProps<typeof SingleSelectControlled>,
    'id' | 'value' | 'onChange'
  > {
  name: string;
  required?: boolean;
  onChange?: (value: string) => void;
}

function SingleSelect({
  name,
  label,
  placeholder,
  disabled,
  options,
  tooltip,
  autoWidth = true,
  isLabelMultiline,
  required,
  onChange,
}: SingleSelectProps) {
  const [{ value }, { error, touched }, { setValue, setTouched }] = useField(
    name.toString(),
  );
  const isError = !!error && !!touched;

  return (
    <SingleSelectControlled
      id={name.toString()}
      label={label}
      isLabelMultiline={isLabelMultiline}
      placeholder={placeholder}
      disabled={disabled}
      options={options}
      tooltip={tooltip}
      autoWidth={autoWidth}
      value={value}
      onChange={newValue => {
        setValue(newValue);
        setTimeout(() => onChange?.(newValue), 0);
      }}
      onBlur={() => {
        setTouched?.(true);
      }}
      isError={isError}
      required={required}
    />
  );
}

export default SingleSelect;
